import template from './project-form.pug';

export const ProjectFormComponent = {
  template,
  bindings: {
    project: '<'
  },
  controller: class ProjectFormComponent {
    constructor($state, $log, $async, Project, AlertBox, Upload) {
      'ngInject';
      this.Upload = Upload;
      this.AlertBox = AlertBox;
      this.$state = $state;
      this.$log = $log;
      this.Project = Project;
      this.save = $async(this.save.bind(this));
      this.uploadLogo = $async(this.uploadLogo.bind(this));
      this.removeLogo = $async(this.removeLogo.bind(this));
      this.loader = false;
    }

    $onInit() {}

    async save() {
      try {
        if (this.project && this.project.id) {
          this.tempProject = await this.Project.updateGroup({
            title: this.project.title,
            color: this.project.color,
            id: this.project.id
          });
          this.AlertBox.addMessage('alert.updated', { type: 'success' });
        }
      } catch (e) {
        this.$log.error(e);
      }

    }

    async uploadLogo() {
      try {
        this.loader = true;
        const response = await this.Upload.upload({
          url: window.apiHost + '/projects/' + this.project.id + '/logo',
          data: { logo: this.logo }
        }).finally(() => {
          this.loader = false;
        });
        this.project.logo_url = response.data;
      } catch (e) {
        this.$log.error(e);
      }
    }

    async removeLogo() {
      try {
        this.loader = true;
        await this.Project.removeLogo(this.project.id);
        this.project.logo_url = null;
        this.loader = false;
      } catch (e) {
        this.$log.error(e);
      }
    }
  }
};
